
export function setUserDetails(userDetail: any) {
    localStorage.setItem('MPUserDetails', JSON.stringify(userDetail));
}

export function getUserDetails() {
    
    const userDetails: any = localStorage.getItem('MPUserDetails');
    if (userDetails !== undefined && userDetails !== null && userDetails !== "") {
        return JSON.parse(userDetails);
    }
    else {
        return null;
    }

}